import React, { Component } from 'react';
import { Size } from '../_util/enum';
import Select from '../select';
export default class MiniSelect extends Component {
    render() {
        return React.createElement(Select, Object.assign({ size: Size.small }, this.props));
    }
}
MiniSelect.Option = Select.Option;
